import React from "react";
import {
  SideNavigation,
  SideNavigationProps,
} from "@amzn/awsui-components-react-v3/polaris";
import { useLocation, useNavigate } from "react-router-dom";
import { PagePaths, SupportUrls } from "../lib/constants";
import { Badge } from "@amzn/awsui-components-react-v3";

interface SideNavProps {
  otpEnabled: boolean;
  isManager: boolean;
}

export const DefaultSideNavigation = ({
  otpEnabled,
  isManager,
}: SideNavProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const activeHref = location.pathname.replace(/\/+$/, "");

  const credManagementNavItems: SideNavigationProps.Link[] = [
    {
      type: "link",
      text: "Register security key",
      href: PagePaths.REGISTER_MFA,
    },
  ];
  const userManagementNavItems: SideNavigationProps.Link[] = [
    {
      type: "link",
      text: "You",
      href: "/users/me",
      info: <Badge color="severity-low">New</Badge>,
    },
  ];

  if (otpEnabled) {
    credManagementNavItems.push({
      type: "link",
      text: "Set OTP PIN",
      href: PagePaths.SET_OTP_PIN,
    });
  }

  credManagementNavItems.push({
    type: "link",
    text: "Set badge PIN",
    href: PagePaths.SET_BADGE_PIN,
  });

  if (isManager) {
    userManagementNavItems.push({
      type: "link",
      text: "Your team",
      href: PagePaths.MANAGE_DIRECTS,
    });
  }

  return (
    <SideNavigation
      items={[
        {
          type: "section-group",
          title: "Credential Management",
          items: credManagementNavItems,
        },
        {
          type: "section-group",
          title: "User Management",
          items: userManagementNavItems,
        },
        { type: "divider" },
        {
          type: "section-group",
          title: "Support",
          items: [
            {
              type: "link",
              text: "#kuiper-iam-interest",
              href: SupportUrls.KIAM_INTEREST_CHANNEL_LINK,
              external: true,
              externalIconAriaLabel: " (opens in new tab)",
            },
            {
              type: "link",
              text: "Access issue",
              href: SupportUrls.ACCESS_ISSUE,
              external: true,
              externalIconAriaLabel: " (opens in new tab)",
            },
            {
              type: "link",
              text: "Report a bug",
              href: SupportUrls.BUG_REPORT,
              external: true,
              externalIconAriaLabel: " (opens in new tab)",
            },
            {
              type: "link",
              text: "Feature request",
              href: SupportUrls.FEATURE_REQUEST,
              external: true,
              externalIconAriaLabel: " (opens in new tab)",
            },
          ],
        },
      ]}
      activeHref={activeHref}
      onFollow={(event) => {
        if (!event.detail.external) {
          event.preventDefault();
          navigate(event.detail.href);
        }
      }}
    />
  );
};
